import { Button } from "@octopusdeploy/design-system-components";
import type { TimelineItem } from "@octopusdeploy/octopus-server-client";
import type { GetLiveStatusRollupBffResponse } from "@octopusdeploy/octopus-server-client/src/resources/getLiveStatusRollupBffResponse";
import * as React from "react";
import { LiveStatusRow } from "./LiveStatusRow";
import { TimelineRow } from "./TimelineRow";
import { loadMoreButton, timeline } from "./styles";
interface TimelineProps {
    timelineData: TimelineItem[];
    loadMore: () => void;
    hasMore: boolean;
    liveStatusData: GetLiveStatusRollupBffResponse | null;
}
const NoLiveStatus = <></>;
const getLiveStatusItem = (data: GetLiveStatusRollupBffResponse) => {
    return data.Status !== "NotSupported" ? (<li key="liveStatusRow">
            <LiveStatusRow data={data}/>
        </li>) : (NoLiveStatus);
};
export const Timeline = (props: TimelineProps) => (<>
        <ul className={timeline}>
            {props.liveStatusData ? getLiveStatusItem(props.liveStatusData) : NoLiveStatus}
            {props.timelineData.map((tli) => (<li key={tli.Id}>
                    <TimelineRow item={tli}/>
                </li>))}
        </ul>
        <div className={loadMoreButton}>{props.hasMore && <Button onClick={props.loadMore} label="Load More" importance="tertiary"/>}</div>
    </>);
